export default __webpack_public_path__ + "static/media/avatar3.40758c50.svg";